import $ from "jquery";

import "./scss/style.scss";
import "slick-carousel";
import { rdtsGetTransients, setAccordeonLabels } from "./js/utilities";
import rdtsSimpleAccordion from "./js/accordion";
import formValidator from "./js/formvalidator";
import alertDialog from "./js/alertDialog";


rdtsGetTransients();

setTimeout(function () {
    $.ajax({
        type: 'POST',
        dataType: 'json',
        url: ajax_object.ajaxUrl,
        data: {
            'action': 'ajaxlogout',
            'security': ajax_object.security
        },
        success: function (data) {
            if (data.loggedout == true) {
                document.location.href = window.location.href;
            }
        }
    });
}, 900000);

$.fn.extend({
    triggerAll: function (events, params) {
        var el = this, i, evts = events.split(' ');
        for (i = 0; i < evts.length; i += 1) {
            el.trigger(evts[i], params);
        }
        return el;
    }
});

$('button.copy').on('click', function (e) {
    e.preventDefault();
    const target = $(this).attr('data-target');
    const copyText = document.getElementById(target);
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(copyText.value);
});

$('[data-action="showLogin"]').on('click', function (e) {
    e.preventDefault();
    alertDialog({
        title: 'Login', content: `
        <form class="login" method="POST" action="">
            <p class="status"></p>
            <div class="form_bereich">
                <div class="form-input d-grid w100">
                    <label for="username">E-Mail</label>
                    <input type="email" name="username" id="username" required />
                </div>
                <div class="form-input d-grid w100">
                    <label for="password">Password</label>
                    <input type="password" name="password" id="password" required />
                </div>
                <div class="d-flex jc-center">
                    <button class="wp-block-button__link wp-element-button" data-action="login" type="submit">Einloggen</button>
                </div>
            </div>
        </form>
    `});
    $('[data-action="login"]').on('click', function (e) {
        e.preventDefault();
        const form = $(this).parents('form').first();
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: ajax_object.ajaxUrl,
            data: {
                'action': 'ajaxlogin',
                'security': ajax_object.security,
                'data': form.serialize()
            },
            success: function (data) {
                form.find('p.status').text(data.message);
                if (data.loggedin == true) {
                    document.location.href = window.location.href;
                }
            }
        });
    });
});

$('.logout').on('click touchend', function (e) {
    e.preventDefault();
    $.ajax({
        type: 'POST',
        dataType: 'json',
        url: ajax_object.ajaxUrl,
        data: {
            'action': 'ajaxlogout',
            'security': ajax_object.security
        },
        success: function (data) {
            if (data.loggedout == true) {
                document.location.href = window.location.href;
            }
        }
    });
});

$('[data-action="initialize"]').on('click', function (e) {
    e.preventDefault();
    $.ajax({
        type: 'POST',
        dataType: 'json',
        url: ajax_object.ajaxUrl,
        data: {
            'action': 'initialisieren',
            'security': ajax_object.security,
            'data': 'go'
        },
        success: function (data) {
            if (data.status == 'ok' && data.token) {
                document.location.href = window.location.href;
            }
        }
    });
});

if ($('#meldungen').length) {
    $.ajax({
        type: 'POST',
        dataType: 'json',
        url: ajax_object.ajaxUrl,
        data: {
            'action': 'get_meldungen',
            'security': ajax_object.security,
            'data': localStorage.getItem('tauthKey') ? localStorage.getItem('tauthKey') : null
        },
        success: function (data) {
            if (data.auth) {
                // ToDo Meldungen anzeigen
            } else {
                $('#tauth').show();
            }
        }
    });
}

if ($('#neue_meldung').length) {
    $('#neue_meldung').on('click', function (e) {
        e.preventDefault();
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: ajax_object.ajaxUrl,
            data: {
                'action': 'get_code',
                'security': ajax_object.security,
                'data': null
            },
            success: function (data) {
                if (data.code) {
                    alertDialog({
                        title: 'Bitte speichern Sie den folgenden Zugangscode', content: `
                        <p><strong class="has-inline-color has-primary-color">Wichtig:</strong> Mit diesem Zugangscode können Sie jederzeit den Bearbeitungsstand einsehen. Daher ist es dringend erforderlich, den Zugangscode jetzt zu speichern.</p> 
                        <p class="has-inline-color has-primary-color"><strong>Ohne Zugangscode, kein Zugriff! Bei Verlust müssen Sie Ihr Anliegen nochmals eingeben!</strong></p>
                        <form id="zur_neue_meldung" method="POST">
                            <div class="form_bereich">
                                <div class="form-input d-flex flex-wrap">
                                    <label for="token" class="w100">Zugangscode</label>
                                    <input type="text" name="mtoken" id="mtoken" value="${data.code}" readonly required />
                                    <button class="wp-block-button__link wp-element-button copy" data-target="mtoken">Kopieren</button>
                                </div>
                                <div class="form-input">
                                    <div class="input-group checkbox flex-wrap">
                                        <input type="checkbox" name="kopiert" id="kopiert" value="Kopiert" required />
                                        <label for="kopiert">Ja, ich habe den Zugangscode kopiert</label>
                                    </div>
                                </div>
                                <div class="d-flex jc-center">
                                    <button class="wp-block-button__link wp-element-button" type="submit">Neue Meldung erstellen</button>
                                </div>
                            </div>
                        </form>
                    `});
                    $('button.copy').on('click', function (e) {
                        e.preventDefault();
                        const target = $(this).attr('data-target');
                        const copyText = document.getElementById(target);
                        copyText.select();
                        copyText.setSelectionRange(0, 99999);
                        navigator.clipboard.writeText(copyText.value);
                    });
                    const form = $('#zur_neue_meldung');
                    const isFormValid = formValidator.validateForm(form);
                    if (!isFormValid) {
                        form.find('button[type="submit"]').prop('disabled', true).addClass('disabled');
                    }
                    form.find('input:not([type="submit"]),select,textarea').on('input change', function () {
                        const isFormValid = formValidator.validateForm(form);
                        if (isFormValid) {
                            form.find('button[type="submit"]').prop('disabled', false).removeClass('disabled');
                        } else {
                            form.find('button[type="submit"]').prop('disabled', true).addClass('disabled');
                        }
                    });
                    form.on('submit', function (e) {
                        e.preventDefault();
                        $.ajax({
                            type: 'POST',
                            dataType: 'json',
                            url: ajax_object.ajaxUrl,
                            data: {
                                'action': 'add_issue',
                                'security': ajax_object.security,
                                'data': form.serialize()
                            },
                            success: function (data) {
                                if (data.iid) {
                                    const newForm = $(`<form method="POST" action="/neue-meldung?iid=${data.iid}" id="go_to_meldung"><input type="hidden" name="mtoken" value="${data.code}" /></form>`);
                                    newForm.insertAfter(form);
                                    form.remove();
                                    $('#go_to_meldung').trigger('submit');
                                }
                            }
                        });
                    });
                } else {
                    // ToDo wenn kein Zugangscode
                }
            }
        });
    });
}

if ($('#old_meldung').length) {
    $('#old_meldung').on('click', function (e) {
        e.preventDefault();
        alertDialog({
            title: 'Zugangscode erforderlich für Zugriff', content: `
            <p>Bei Erstellung der Meldung haben Sie ein eindeutigen Zugangscode erhalten. Bitten fügen Sie dieses in die untenstehende Eingabe ein</p> 
            <form id="zur_old_meldung" method="POST">
                <div class="form_bereich">
                    <div class="form-input d-grid w100">
                        <label for="token">Zugangscode</label>
                        <input type="text" name="token" id="token" placeholder="z.B. fnj4u4inon4r2n" required />
                        <div class="form-error">Für Ihr angegebenen Zugangscode gibt es keine Meldung.</div>
                    </div>
                    <div class="d-flex jc-center">
                        <button class="wp-block-button__link wp-element-button d-flex jc-center" type="submit">Zur Meldung</button>
                    </div>
                </div>
            </form>
        `});
        const form = $('#zur_old_meldung');
        const isFormValid = formValidator.validateForm(form);
        if (!isFormValid) {
            form.find('button[type="submit"]').prop('disabled', true).addClass('disabled');
        }
        form.find('input:not([type="submit"]),select,textarea').on('input change', function () {
            const isFormValid = formValidator.validateForm(form);
            if (isFormValid) {
                form.find('button[type="submit"]').prop('disabled', false).removeClass('disabled');
            } else {
                form.find('button[type="submit"]').prop('disabled', true).addClass('disabled');
            }
        });
        form.on('submit', function (e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                dataType: 'json',
                url: ajax_object.ajaxUrl,
                data: {
                    'action': 'check_code',
                    'security': ajax_object.security,
                    'data': form.serialize()
                },
                success: function (data) {
                    if (data.iid) {
                        const newForm = $(`<form method="POST" action="/meldung?iid=${data.iid}" id="go_to_meldung"><input type="hidden" name="token" value="${data.token}" /></form>`);
                        newForm.insertAfter(form);
                        form.remove();
                        $('#go_to_meldung').trigger('submit');
                    } else {
                        $('#zur_old_meldung #token').siblings('.form-error').show();
                    }
                }
            });
        });

    });
}

const isFormValid = formValidator.validateForm($('#tauth'));
if (!isFormValid) {
    $('#tauth button[type="submit"]').prop('disabled', true).addClass('disabled');
}

$('#tauth').find('input:not([type="submit"]),select,textarea').on('input change', function () {
    const isFormValid = formValidator.validateForm($('#tauth'));
    if (isFormValid) {
        $('#tauth button[type="submit"]').prop('disabled', false).removeClass('disabled');
    } else {
        $('#tauth button[type="submit"]').prop('disabled', true).addClass('disabled');
    }
});

rdtsSimpleAccordion($('.accordion-container'));

// $('#tauth').on('submit', function (e) {
//     e.preventDefault();
//     const form = $(this);
//     $.ajax({
//         type: 'POST',
//         dataType: 'json',
//         url: ajax_object.ajaxUrl,
//         data: {
//             'action': 'tauth',
//             'security': ajax_object.security,
//             'data': form.serialize()
//         },
//         success: function (data) {
//             if (data.sent) {
//                 const tauthKey = localStorage.getItem('tauthKey') ? localStorage.getItem('tauthKey') : null;
//                 alertDialog({
//                     title: 'Ihr Zugangscode', content: `
//                 <form id="acode" method="post">
//                     <input type="hidden" name="tkey" value="${tauthKey}" />
//                     <div class="form-input d-grid flex-grow">
//                         <label for="acode">Ihr Zugangscode</label>
//                         <div class="input-group d-flex gap-small flex-wrap">
//                             <input type="text" name="acode" id="acode" required />
//                             <div class="form-error">Ihr Zugangscode scheint nicht richtig zu sein.</div>
//                         </div>
//                     </div>
//                     <div class="d-flex jc-center">
//                         <button type="submit" class="wp-element-button">Senden</button>
//                     </div>
//                 </form>
//                 `});
//                 $('#acode').on('submit', function (e) {
//                     e.preventDefault();
//                     const form = $(this);
//                     $.ajax({
//                         type: 'POST',
//                         dataType: 'json',
//                         url: ajax_object.ajaxUrl,
//                         data: {
//                             'action': 'acode',
//                             'security': ajax_object.security,
//                             'data': form.serialize()
//                         },
//                         success: function (data) {
//                             if (data.auth) {
//                                 document.location.href = window.location.href;
//                             } else {
//                                 $('#acode').siblings('.form-error').first().show();
//                             }
//                         }
//                     });
//                 });
//             } else if (data.error == 'wrong') {
//                 $('#token').siblings('.form-error').first().show();
//             } else {
//                 $('#token').siblings('.form-error').first().text('E-Mail konnte nicht gesendet werden. Bitte versuchen Sie später erneut.').show();
//             }
//         }
//     });
// });

if ($('#neue-meldung-meta').length) {
    const form = $('#neue-meldung-meta');

    const isFormValid = formValidator.validateForm(form);
    if (!isFormValid) {
        form.find('button[type="submit"]').prop('disabled', true).addClass('disabled');
    }
    form.find('input:not([type="submit"]),select,textarea').on('input change', function () {
        setAccordeonLabels();
        const isFormValid = formValidator.validateForm(form);
        if (isFormValid) {
            form.find('button[type="submit"]').prop('disabled', false).removeClass('disabled');
        } else {
            form.find('button[type="submit"]').prop('disabled', true).addClass('disabled');
        }
    });
    form.on('submit', function (e) {
        e.preventDefault();
        const form_data = new FormData();
        if (form.find('#files').prop('files').length > 0) {
            const files = $("#files").get(0).files;
            for (var i = 0; i < files.length; i++) {
                form_data.append("file" + i, files[i]);
            }
        }
        form_data.append('action', 'save_issue_meta');
        form_data.append('formdata', form.serialize());
        form_data.append('security', ajax_object.security);

        const iid = form.find('input[name="iid"]').val();
        const token = form.find('input[name="token"]').val();

        $.ajax({
            url: ajax_object.ajaxUrl,
            type: 'POST',
            data: form_data,
            cache: false,
            dataType: 'json',
            processData: false,
            contentType: false,
            success: function (data) {
                if (data.saved) {
                    $('#zur_meldung').show();
                    $('#neue-meldung-meta').slideUp();
                } else {
                    // ToDo wenn nicht gespeichtert
                }
            }
        });
    });
    $('input[name="meldung-type[]"]').on('change', function () {
        const input = $(this);
        if (input.val() != 'vertraulich') {
            $('.vertraulich').slideUp('fast');
        } else {
            $('.vertraulich').slideDown('fast');
        }
    });
}
if ($('#add-meldung').length) {
    const isFormValid = formValidator.validateForm($('#add-meldung'));
    if (!isFormValid) {
        $('#add-meldung button[type="submit"]').prop('disabled', true).addClass('disabled');
    }

    $('#add-meldung').find('input:not([type="submit"]),select,textarea').on('input change', function () {
        const isFormValid = formValidator.validateForm($('#add-meldung'));
        if (isFormValid) {
            $('#add-meldung button[type="submit"]').prop('disabled', false).removeClass('disabled');
        } else {
            $('#add-meldung button[type="submit"]').prop('disabled', true).addClass('disabled');
        }
    });
}

$('[data-action="gotom"]').on('click', function (e) {
    e.preventDefault();
    const link = $(this);
    const row = link.parents('tr').first();
    const form = row.find('form');
    form.trigger('submit');
});

$('.schliessen-trigger').on('click', function (e) {
    e.preventDefault();
    const link = $(this);
    const iid = link.attr('data-iid') ? link.attr('data-iid') : null;
    const dialog = alertDialog({
        title: 'Vorgang schliessen', content: `
        <p>Wollen Sie den Vorgang wirklich schliessen? Eine Bearbeitung ist danach nicht mehr möglich.</p>
        <div class="d-flex jc-center"><a href="#" class="wp-block-button__link wp-element-button schliessen">Vorgang schliessen</a></div>
    `});
    $('.schliessen').on('click', function (e) {
        e.preventDefault();
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: ajax_object.ajaxUrl,
            data: {
                'action': 'close_meldung',
                'security': ajax_object.security,
                'data': iid
            },
            success: function (data) {
                if (data.saved) {
                    link.remove();
                    $('.alert_dialog').remove();
                    $('.form-container.form').remove();
                } else {
                    // ToDo wenn nicht gespeichtert
                }
            }
        });
    });
});